module.exports = __webpack_public_path__ + "static/media/verde.be5caf4a.png";